import { gql } from '@apollo/client'
import { ID } from '../IQueryData'
import { IParkingPoolProfile } from '../parkingPool/getTenantParkingPoolUsers'

export interface IParkingPoolConfig {
  id: ID
  disabled: boolean
  isValid: boolean
  placesCountContract: number
  maxActiveUserCount: number
  maxActiveUserCountUnlimited?: boolean | null
  maxAdvanceDays: number
  maxDurationDays: number
  maxReservationCountPerUser: number
  parkingPass?: {
    productId: number
    parking?: {
      name: string
    } | null
  } | null
  profiles?: IParkingPoolProfile[]
  poolParkings?: {
    id: ID
    placesCountContract?: number | null
    parking?: {
      id: ID
      name: string
      mapPdfUrl?: string | null
      mapPdfUrlEn?: string | null
      mapThumbnailUrl?: string | null
    } | null
  }[]
  placesAggregate?: {
    count: number
  } | null
}

export interface IGetTenantParkingPoolConfigVars {
  name: string
}

export interface IGetTenantParkingPoolConfigData {
  getTenant: {
    name: string
    parkingPool?: IParkingPoolConfig | null
  } | null
}

export const GET_TENANT_PARKING_POOL_CONFIG = gql`
  query getTenantParkingPoolConfig($name: String) {
    getTenant(name: $name) {
      name
      parkingPool: parking_pool {
        id
        disabled
        isValid: is_valid
        placesCountContract: places_count_contract
        maxActiveUserCount: max_active_user_count
        maxActiveUserCountUnlimited: max_active_user_count_unlimited
        maxAdvanceDays: max_advance_days
        maxDurationDays: max_duration_days
        maxReservationCountPerUser: max_reservation_count_per_user
        parkingPass: parking_pass {
          productId: amano_productno
          parking {
            name
          }
        }
        profiles(filter: { not: { disabled: true } }) {
          id
          name
          isDefault: is_default
          maxActiveUserCount: max_active_user_count
          maxActiveUserCountUnlimited: max_active_user_count_unlimited
          maxAdvanceDays: max_advance_days
          maxAdvanceDaysUnlimited: max_advance_days_unlimited
          maxDurationDays: max_duration_days
          maxDurationDaysUnlimited: max_duration_days_unlimited
          maxReservationCountPerUser: max_reservation_count_per_user
          maxReservationCountPerUserUnlimited: max_reservation_count_per_user_unlimited
          usersAggregate {
            count
          }
          parkings {
            parking {
              name
            }
          }
        }
        poolParkings: pool_parkings {
          id
          placesCountContract: places_count_contract
          parking {
            id
            name
            mapPdfUrl: map_pdf_url
            mapPdfUrlEn: map_pdf_url_en
            mapThumbnailUrl: map_thumbnail_url
          }
        }
        placesAggregate {
          count
        }
      }
    }
  }
`
